import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DSTheme } from '../../../styles/themes/types';

const useStyles = makeStyles((theme: DSTheme) => ({
  tableRow: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '528px',

    background: theme.palette.background.elevation1,
    [theme.breakpoints.up('md')]: {
      maxWidth: '894px',
    },
  },
  tableRowContent: {
    width: '100%',
    height: '100%',
    boxShadow: 'inset 0px -1px 0px #808191;',
  },
}));

const TableRow: React.FC = ({ children }) => {
  const classes = useStyles();

  return (
    <div className={classes.tableRow}>
      <div className={classes.tableRowContent}>{children}</div>
    </div>
  );
};

export default TableRow;
